import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchMatStockData, fetchSingleMatStock } from '../../../Store/PHPSlice/MatStock';
import { Grid, Paper } from '@mui/material';
import { BallotOutlined } from '@mui/icons-material';

const MatStockView = () => {
  const { Id } = useParams();
  const [purData, setPurData] = useState([]);
  const [matObj, setMatObj] = useState({});
  const [inwardData, setInwardData] = useState([]);
  const [outwardData, setOutwardData] = useState([]);

  const pidata = useSelector((state) => state.MatStockData.singleMatStock);

  const materials = useSelector((state) => state.MatStockData.matStock || { data: [] });
  const dispatch = useDispatch();
  useEffect(() => {
    if (Id) {
      dispatch(fetchSingleMatStock(Id));
      dispatch(fetchMatStockData(Id));
    }
  }, [dispatch, Id]);

  useEffect(() => {
    if (materials) {
      const obj = materials?.data;
      const inwarddata = materials?.inward_data;
      const outwarddata = materials?.outward_data;

      setMatObj(obj);
      setInwardData(inwarddata);
      setOutwardData(outwarddata);
    }
  }, [materials]);


  const handleViewClick = (form) => {
    // Construct the URL with query parameters or use a placeholder route
    const url = `/BaleLumpView?form=${encodeURIComponent(JSON.stringify(form))}`;

    // Open the URL in a new tab
    window.open(url, '_blank', 'width=900,height=600,scrollbars=yes,resizable=yes');
  };
  // console.log("item=>", materials);
  return (
    <>
      <Grid item xs={12}>
        <Paper style={{ padding: '3vh', margin: '0' }}>
          <div style={{ margin: '1% 0%', width: '100%' }}>

            <h3 className='centered-heading'>Material Stock Info</h3>
            <div className="dashed-line"></div>

            {/* {pidata?.data?.length > 0 ? (
              pidata.data.map((val, valIndex) => (
                <div key={valIndex}>
                  <table style={{ margin: '1% 5%', fontSize: '15px' }}>
                    <tbody>
                      <tr>
                        <td style={{ width: '200px' }}>
                          <b>Date</b>:
                        </td>
                        <td
                          style={{
                            width: '30vw',
                            padding: '0.2% 1.5%',
                            fontSize: '15px',
                            fontWeight: 'bold',
                            color: '#333',
                          }}
                          className='light-color'
                        >
                          {new Date().toLocaleDateString('en-IN')}
                        </td>
                      </tr>
                      <tr>
                        <td><b>Location:</b></td>
                        <td className='light-color'>{val.locNm}</td>
                      </tr>
                      <tr>
                        <td><b>Material Name:</b></td>
                        <td className='light-color'>{val.materialNm}</td>
                      </tr>

                      <tr>
                        <td><b>Size:</b></td>
                        <td className='light-color'>{val.size}</td>
                      </tr>
                      <tr>
                        <td><b>Description:</b></td>
                        <td className='light-color'>{val.description}</td>
                      </tr>

                      <tr>
                        <td><b>Total Stock Qty:</b></td>
                        <td className='light-color' style={{ color: 'green' }}><b>{val.stkqty}</b></td>
                      </tr>

                      <tr>
                        <td><b>Given Qty:</b></td>
                        <td className='light-color' style={{ color: 'blue' }}><b>{val.givenqty}</b></td>
                      </tr>

                      <tr>
                        <td><b>Total Balance Qty:</b></td>
                        <td className='light-color' style={{ color: 'red' }}><b>{val.balqty}</b></td>
                      </tr>
                    </tbody>
                  </table>

                  === Stock Inward Table ===
                  <h4 style={{ marginLeft: '5%', marginTop: '2%', color: 'green' }}>Stock Inward Details</h4>
                  <table className='table table-bordered' style={{ width: '90%', margin: '0 5%' }}>
                    <thead style={{ background: '#d4edda' }}>
                      <tr>
                        <th>Sr.No.</th>
                        <th>Date</th>
                        <th>Inward No</th>
                        <th>Per Packet Qty</th>
                        <th>Packet Qty</th>
                        <th>Inward Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {val.inward && val.inward.length > 0 ? (
                        val.inward.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{item.dt}</td>
                            <td>{item.inwardNo}</td>
                            <td>{item.pkt}</td>
                            <td>{item.pktqty}</td>
                            <td>{item.qty}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} style={{ textAlign: 'center', color: '#888' }}>
                            No inward records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                    === ✅ FOOTER for Total Inward ===
                    {val.inward && val.inward.length > 0 && (
                      <tfoot style={{ background: '#fff', fontWeight: 'bold' }}>
                        <tr>
                          <td colSpan={4} style={{ textAlign: 'right' }}><b>Total </b></td>
                          <td>
                            <b>        {val.inward.reduce((sum, item) => sum + parseFloat(item.pktqty || 0), 0)}
                            </b>
                          </td>
                          <td>
                            <b>        {val.inward.reduce((sum, item) => sum + parseFloat(item.qty || 0), 0)}
                            </b>
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>

                  === Stock Outward Table ===
                  <h4 style={{ marginLeft: '5%', marginTop: '2%', color: 'red' }}>Stock Outward Details</h4>
                  <table className='table table-bordered' style={{ width: '90%', margin: '0 5%' }}>
                    <thead style={{ background: '#f8d7da' }}>
                      <tr>
                        <th>Sr.No.</th>
                        <th>Date</th>
                        <th>Outward No</th>
                        <th>Employee Name</th>
                        <th>Outward Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {val.outward && val.outward.length > 0 ? (
                        val.outward.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{item.dt}</td>
                            <td>{item.outwardNo}</td>
                            <td>{item.empNm}</td>
                            <td>{item.qty}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} style={{ textAlign: 'center', color: '#888' }}>
                            No outward records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                    === ✅ FOOTER for Total Outward ===
                    {val.outward && val.outward.length > 0 && (
                      <tfoot style={{ background: '#ffff', fontWeight: 'bold' }}>
                        <tr>
                          <td colSpan={4} style={{ textAlign: 'right' }}><b>Total Outward Qty</b></td>
                          <td>
                            <b>
                              {val.outward.reduce((sum, item) => sum + parseFloat(item.qty || 0), 0)}
                            </b>
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div> // ✅ Each map element must close properly
              ))
            ) : (
              <p className='text-center mt-3'>No data found or loading...</p>
            )} */}

            {materials && matObj ?
              <div>
                <table style={{ margin: '1% 5%', fontSize: '15px' }}>
                  <tbody>
                    <tr>
                      <td><b>Material Name:</b></td>
                      <td className='light-color'>{matObj?.materialNm}</td>
                    </tr>
                    <tr>
                      <td><b>Location:</b></td>
                      <td className='light-color'>{matObj?.locNm}</td>
                    </tr>


                    <tr>
                      <td><b>Size:</b></td>
                      <td className='light-color'>{matObj?.size}</td>
                    </tr>
                    <tr>
                      <td><b>Description:</b></td>
                      <td className='light-color'>{matObj?.description}</td>
                    </tr>
                    <tr>
                      <td><b>Barcode:</b></td>
                      <td className='light-color'>{matObj?.barcode}</td>
                    </tr>
                    <tr>
                      <td><b>M. Qty:</b></td>
                      <td className='light-color'>{matObj?.mqty} {" "} {matObj?.mtype}</td>
                    </tr>

                    <tr>
                      <td><b>Packet Qty:</b></td>
                      <td className='light-color'>{matObj?.perpktqty} {" "} {matObj?.ptype}</td>
                    </tr>

                    {/* pp qty */}
                    {/* <tr>
                      <td><b>Stock Packet Qty:</b></td>
                      <td className='light-color' style={{ color: 'green' }}><b>{matObj?.actpqty}</b></td>
                    </tr>

                    <tr>
                      <td><b>Sale Packet Qty:</b></td>
                      <td className='light-color' style={{ color: 'blue' }}><b>{(Number(matObj.spqty)).toFixed(2)}</b></td>
                    </tr>

                    <tr>
                      <td><b>Balance Packet Qty:</b></td>
                      <td className='light-color' style={{ color: 'red' }}><b>{matObj.balpqty}</b></td>
                    </tr> */}

                    {/* mtr */}
                    {/* {matObj?.mtype !== "Pcs" &&
                      <>
                        <tr>
                          <td><b>Stock Mtr:</b></td>
                          <td className='light-color' style={{ color: 'green' }}><b>{matObj?.actmtr}</b></td>
                        </tr>

                        <tr>
                          <td><b>Sale Mtr:</b></td>
                          <td className='light-color' style={{ color: 'blue' }}><b>{(Number(matObj?.smtr)).toFixed(2)}</b></td>
                        </tr>

                        <tr>
                          <td><b>Balance Mtr:</b></td>
                          <td className='light-color' style={{ color: 'red' }}><b>{matObj.balmtr}</b></td>
                        </tr>
                      </>} */}


                    {/* Inch */}
                    {/* {matObj?.mtype !== "Pcs" &&
                      <>
                        <tr>
                          <td><b>Stock Inch:</b></td>
                          <td className='light-color' style={{ color: 'green' }}><b>{matObj?.actInch}</b></td>
                        </tr>

                        <tr>
                          <td><b>Sale Inch:</b></td>
                          <td className='light-color' style={{ color: 'blue' }}><b>{(Number(matObj?.sInch)).toFixed(2)}</b></td>
                        </tr>

                        <tr>
                          <td><b>Balance Inch:</b></td>
                          <td className='light-color' style={{ color: 'red' }}><b>{matObj.balInch}</b></td>
                        </tr>
                      </>} */}


                    {/* totqty */}
                    {/* {matObj?.mtype === "Pcs" &&
                      <>
                        <tr>
                          <td><b>Stock Total Qty:</b></td>
                          <td className='light-color' style={{ color: 'green' }}><b>{matObj?.actTotqty}</b></td>
                        </tr>

                        <tr>
                          <td><b>Sale Total Qty:</b></td>
                          <td className='light-color' style={{ color: 'blue' }}><b>{(Number(matObj?.sTotqty)).toFixed(2)}</b></td>
                        </tr>

                        <tr>
                          <td><b>Balance Total Qty:</b></td>
                          <td className='light-color' style={{ color: 'red' }}><b>{matObj.balTotqty}</b></td>
                        </tr>
                      </>} */}

                  </tbody>
                </table>
                <h4 style={{ marginLeft: '5%', marginTop: '2%', color: 'green' }}>Total Current Stock Details</h4>
                <table className='table table-bordered' style={{ width: '90%', margin: '0 5%' }}>
                  <thead style={{ background: '#d4edda' }}>
                    <tr>
                      <th>Stock Packet Qty.</th>
                      <th>Sale Packet Qty</th>
                      <th>Balance Packet Qty</th>
                      <th>Stock Mtr</th>
                      <th>Sale Mtr</th>
                      <th>Balance Mtr</th>
                      <th>Stock Inch.</th>
                      <th>Sale Inch</th>
                      <th>Balance Inch</th>
                      <th>Stock Total Qty.</th>
                      <th>Sale Total Qty</th>
                      <th>Balance Total Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{matObj?.actpqty}</td>
                      <td>{(Number(matObj?.spqty)).toFixed(2)}</td>
                      <td>{matObj.balpqty}</td>
                      <td>{matObj?.actmtr}</td>
                      <td>{(Number(matObj?.smtr)).toFixed(2)}</td>
                      <td>{matObj.balmtr}</td>
                      <td>{matObj?.actInch}</td>
                      <td>{(Number(matObj?.sInch)).toFixed(2)}</td>
                      <td>{matObj.balInch}</td>
                      <td>{matObj?.actTotqty}</td>
                      <td>{(Number(matObj?.sTotqty)).toFixed(2)}</td>
                      <td>{matObj.balTotqty}</td>
                    </tr>

                  </tbody>
                </table>


                {/* === Stock Inward Table === */}
                <h4 style={{ marginLeft: '5%', marginTop: '2%', color: 'green' }}>Stock Inward Details</h4>
                <table className='table table-bordered' style={{ width: '90%', margin: '0 5%' }}>
                  <thead style={{ background: '#d4edda' }}>
                    <tr>
                      <th>Sr.No.</th>
                      <th>Date</th>
                      <th>Location</th>
                      <th>Inward Type</th>
                      <th>Inward No</th>
                      <th>Purchase Inward No</th>
                      <th>Inward P. Qty</th>
                      <th>Inward Mtr</th>
                      <th>Inward Inch</th>
                      <th>Inward Total Qty.</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inwardData && inwardData.length > 0 ? (
                      inwardData.map((item, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{item.dt}</td>
                          <td>{item.locationNm}</td>
                          <td>{item.inwardType}</td>
                          <td>{item.inwardNo}</td>
                          <td>{item.piNo}</td>
                          <td>{item.inwpqty}</td>
                          <td>{item.totmtr}</td>
                          <td>{item.totinch}</td>
                          <td>{item.totqty}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={10} style={{ textAlign: 'center', color: '#888' }}>
                          No inward records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                  {/* === ✅ FOOTER for Total Inward === */}

                  <tfoot style={{ background: '#fff', fontWeight: 'bold' }}>
                    <tr>
                      <td colSpan={6} style={{ textAlign: 'right' }}><b>Total </b></td>
                      <td>
                        <b>{inwardData?.reduce((sum, item) => sum + parseFloat(item.inwpqty || 0), 0)}</b>
                      </td>
                      <td>
                        <b>{inwardData?.reduce((sum, item) => sum + parseFloat(item.totmtr || 0), 0)}</b>
                      </td>
                      <td>
                        <b>{inwardData?.reduce((sum, item) => sum + parseFloat(item.totinch || 0), 0)}</b>
                      </td>
                      <td>
                        <b>{inwardData?.reduce((sum, item) => sum + parseFloat(item.totqty || 0), 0)}</b>
                      </td>
                    </tr>
                  </tfoot>

                </table>


                {/* === Stock Outward Table === */}
                <h4 style={{ marginLeft: '5%', marginTop: '2%', color: 'red' }}>Stock Outward Details</h4>
                <table className='table table-bordered' style={{ width: '90%', margin: '0 5%' }}>
                  <thead style={{ background: '#f8d7da' }}>
                    <tr>
                      <th>Sr.No.</th>
                      <th>Date</th>
                      <th>Outward No</th>
                      <th>SO No.</th>
                      <th>Department</th>
                      <th>Employee Name</th>
                      <th>Outward P.Qty</th>
                      <th>Outward Mtr</th>
                      <th>Outward Inch</th>
                      <th>Outward Total Qty.</th>
                    </tr>
                  </thead>
                  <tbody>
                    {outwardData && outwardData.length > 0 ? (
                      outwardData.map((item, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{item.dt}</td>
                          <td>{item.outwardNo}</td>
                          <td>{item.sono}</td>
                          <td>{item.departNm}</td>
                          <td>{item.empNm}</td>
                          <td>{item.outpqty}</td>
                          <td>{item.outmtr}</td>
                          <td>{item.outInch}</td>
                          <td>{item.outTotqty}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={9} style={{ textAlign: 'center', color: '#888' }}>
                          No outward records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot style={{ background: '#ffff', fontWeight: 'bold' }}>
                    <tr>
                      <td colSpan={6} style={{ textAlign: 'right' }}><b>Total Outward Qty</b></td>
                      <td>
                        <b>
                          {outwardData?.reduce((sum, item) => sum + parseFloat(item.outpqty || 0), 0)}
                        </b>
                      </td>
                      <td>
                        <b>
                          {outwardData?.reduce((sum, item) => sum + parseFloat(item.outmtr || 0), 0)}
                        </b>
                      </td>
                      <td>
                        <b>
                          {outwardData?.reduce((sum, item) => sum + parseFloat(item.outInch || 0), 0)}
                        </b>
                      </td>
                      <td>
                        <b>
                          {outwardData?.reduce((sum, item) => sum + parseFloat(item.outTotqty || 0), 0)}
                        </b>
                      </td>
                    </tr>
                  </tfoot>

                </table>
              </div> :
              (
                <p className='text-center mt-3'>No data found or loading...</p>
              )
            }

          </div>

        </Paper>
      </Grid>
    </>
  );
}

export default MatStockView;
